import { apiFetchWithRetry } from './apiFetch';

export interface AiUsageRow {
  tier: string;
  feature: string;
  model: string;
  calls: number;
  failedCalls: number;
  inputTokens: number;
  outputTokens: number;
  totalTokens: number;
  /** Null when this model has no entry in the configured rate card. */
  costUsd: number | null;
}

export interface AiUsageTierTotal {
  tier: string;
  calls: number;
  totalTokens: number;
  costUsd: number | null;
  activeUsers: number;
}

export interface AiUsageReport {
  windowDays: number;
  from: string;
  rateCardConfigured: boolean;
  modelsMissingRates: string[];
  totals: {
    calls: number;
    totalTokens: number;
    costUsd: number | null;
    byTier: AiUsageTierTotal[];
  };
  rows: AiUsageRow[];
}

export const aiUsageService = {
  async get(days: number): Promise<AiUsageReport> {
    const response = await apiFetchWithRetry(`/v1/admin/ai-usage?days=${encodeURIComponent(String(days))}`, { method: 'GET' });
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error((body as { message?: string }).message || 'Failed to load AI usage');
    }
    return (await response.json()) as AiUsageReport;
  },
};
